<script setup>
import { ref, computed, defineEmits } from 'vue';
import ProBadge from './ProBadge.vue';
const props = defineProps({
    options: {
        type: Object,
        default: () => {
            return {
                'one': 'One',
                'two': 'Two',
                'three': 'Three',
            }
        }
    },
    modelValue: {
        type: String,
        default: 'one', // Default value should match one of the keys in options
    },
    width: {
        type: String,
        default: '85px',
    },
    locked: {
        type: Array,
        default: () => {
            return [ 'custom' ];
        }
    }
});


const css = computed(() => {
    const index = Object.keys(props.options).indexOf(props.modelValue);

    if ( index == 0) {
        return `transform: translateX(0); width: ${props.width};`;
    }

    return `transform: translateX(${index * 100}%); width: ${props.width};`;
});

const emit = defineEmits(['update:modelValue', 'change']);
const select = (key) => {

    // If locked.
    if ( props.locked.includes(key) && isLocked.value ) {
        return;
    }

    props.modelValue = key;
    emit('update:modelValue', key);
    emit('change', key);
};

const move = (direction) => {
    const keys = Object.keys(props.options);
    const index = keys.indexOf(props.modelValue);

    if ( direction == 'next' && index < keys.length - 1 ) {

        // If locked.
        if ( props.locked.includes(keys[index + 1]) ) {
            return move('next');
        }

        select( keys[index + 1] );
    } else if ( direction == 'prev' && index > 0 ) {

        // If locked.
        if ( props.locked.includes(keys[index - 1]) ) {
            return move('prev');
        }

        select( keys[index - 1] );
    }
};

const isLocked = computed( () => !formychat_admin_vars.is_premium ); 
</script>

<template>
   <div class="w-fit ring-inset font-medium p-1 h-11 ring-1 gap-0 ring-slate-200 bg-white rounded shadow-sm">
    <div class="relative  text-slate-500 flex items-center justify-center h-full child:flex child:items-center child:justify-center cursor-pointer child:transition overflow-hidden"
    tabindex="1" @keydown.right="move('next')" @keydown.left="move('prev')">
        <div v-for="(label, key) in props.options" :key="key" class="z-10 h-full transition outline-none flex items-center gap-1" :style="{width: props.width}" @click.prevent="select( key )" :class="{ 'text-white' : props.modelValue == key, 'hover:text-indigo-600' : props.modelValue !== key && !props.locked.includes(key) , 'opacity-60 formychat-locked' : props.locked.includes(key) && isLocked }"
        >
            <svg v-if="props.locked.includes(key) && isLocked" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" class="fill-current w-[14px]" viewBox="0 0 30 30">
                <path d="M 15 2 C 11.145666 2 8 5.1456661 8 9 L 8 11 L 6 11 C 4.895 11 4 11.895 4 13 L 4 25 C 4 26.105 4.895 27 6 27 L 24 27 C 25.105 27 26 26.105 26 25 L 26 13 C 26 11.895 25.105 11 24 11 L 22 11 L 22 9 C 22 5.2715823 19.036581 2.2685653 15.355469 2.0722656 A 1.0001 1.0001 0 0 0 15 2 z M 15 4 C 17.773666 4 20 6.2263339 20 9 L 20 11 L 10 11 L 10 9 C 10 6.2263339 12.226334 4 15 4 z"></path>
            </svg>
            {{ label }}
            
        </div>
        <div class="absolute rounded bg-indigo-600 left-0 z-0 h-full top-0 transition-all duration-200" :style="css"></div>
    </div>
   </div>
</template>
